import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CaseCommunicationService } from "@secca/core/services/case-communication.service";
import { CaseHistoryType } from "@secca/shared/enums/case-history-type";
import { CaseEmail } from "@secca/shared/models/case-email";
import { CaseHistoryCommEntry } from "@secca/shared/models/caseHistoryEntry";
import { PROTECTED_IDENTITY } from "@secca/core/services/case-communication.service";

@Component({
    selector: 'app-case-summary-email-fax-modal',
    templateUrl: './case-summary-email-fax-modal.component.html',
    styleUrls: ['./case-summary-email-fax-modal.component.scss'],
    standalone: false
})
export class CaseSummaryEmailFaxModalComponent implements OnInit {
  @Input()
  entry: CaseHistoryCommEntry;

  @Output()
  closed: EventEmitter<void> = new EventEmitter();

  caseEmail: CaseEmail;
  internalSummaryBeforeChange: string;
  private PROTECTED_IDENTITY = PROTECTED_IDENTITY;

  constructor(private caseCommunicationService: CaseCommunicationService) {}

  ngOnInit() {
    this.internalSummaryBeforeChange = this.entry.updatedInternalSummary;

    this.loadData();
  }

  saveCaseSummary() {
    this.caseEmail.internalSummary = this.entry.updatedInternalSummary;
    if (this.isEmail()) {
      this.caseEmail.emailId = this.entry.emailId;
      this.caseCommunicationService.updateCaseEmail(this.caseEmail).subscribe(
        result => {
          this.internalSummaryBeforeChange = result.internalSummary;
          this.close();
        }
      );
    } else if (this.isUpload()) {
      this.caseEmail.emailId = this.entry.emailId;
      this.caseCommunicationService.updateCaseUpload(this.caseEmail).subscribe(
        result => {
          this.internalSummaryBeforeChange = result.internalSummary;
          this.close();
        }
      );
    } else {
      this.caseEmail.faxId = this.entry.faxId;
      this.caseCommunicationService.updateCaseFax(this.caseEmail).subscribe(
        result => {
          this.internalSummaryBeforeChange = result.internalSummary;
          this.close();
        }
      );
    }
  }

  close(): void {
    this.closed.emit();
  }

  isEmail(): boolean {
    return (
      this.entry.caseHistoryType === CaseHistoryType.EMAIL ||
      this.entry.caseHistoryType === CaseHistoryType.EMAIL_RECEIVE ||
      this.entry.caseHistoryType === CaseHistoryType.EMAIL_UPDATE
    );
  }

  isFax(): boolean {
    return (
      this.entry.caseHistoryType === CaseHistoryType.FAX ||
      this.entry.caseHistoryType === CaseHistoryType.FAX_RECEIVE ||
      this.entry.caseHistoryType === CaseHistoryType.FAX_UPDATE
    );
  }
  isUpload(): boolean {
    return (
      this.entry.caseHistoryType === CaseHistoryType.DOCUMENT_UPLOAD ||
      this.entry.caseHistoryType === CaseHistoryType.DOCUMENT_UPLOAD_UPDATE
    );
  }

  private loadData() {
    if (this.isEmail() || this.isFax()) {
      this.caseCommunicationService.getEmailBody(this.isEmail() ? this.entry.emailId : this.entry.faxId).subscribe(
        result => {
          this.entry.content = result;
        },
        error => console.log(error)
      );
    } else {
      this.entry.content = 'Securely uploaded files';
    }
    this.isEmail() ? this.getCaseEmail() : (this.isFax() ? this.getCaseFax() : this.getCaseUpload());
  }

  private getCaseEmail() {
    this.caseCommunicationService.getCaseEmail(this.entry.emailId).subscribe(
      result => {
        this.caseEmail = result;
      },
      error => console.log(error)
    );
  }

  private getCaseFax() {
    this.caseCommunicationService.getCaseFax(this.entry.faxId).subscribe(
      result => {
        this.caseEmail = result;
      },
      error => console.log(error)
    );
  }

  private getCaseUpload() {
    this.caseCommunicationService.getCaseUpload(Number(this.entry.emailId)).subscribe(
      result => {
        this.caseEmail = result;
      },
      error => console.log(error)
    );
  }
  get mailDate() {
    if (this.caseEmail?.receivedDate) {
      return this.caseEmail.receivedDate;
    } else {
      return this.entry?.actionTime;
    }
  }

  get internalSummaryHasBeenUpdated() {
    if (this.entry == null) {
      return false;
    }
    return this.entry.updatedInternalSummary !== this.internalSummaryBeforeChange;
  }
}
